import { useEffect } from "react";

const useNotifyParentFrame = (event) => {
  useEffect(() => {
    window.parent.postMessage([event], "*");
  }, [event]);
};

export { useNotifyParentFrame }
